import { FC, ReactNode } from 'react';
import { ListGroup } from 'react-bootstrap';

interface ListViewProps {
  children: ReactNode;
}

const ListView: FC<ListViewProps> = ({ children }) => {
  return <ListGroup as="ul">{children}</ListGroup>;
};

export default ListView;
